import { ViewContainerRef, Directive } from '@angular/core';

@Directive({
  selector: '[agModalHost]'
})
export class ModalHostDirective {
  constructor(public viewContainerRef: ViewContainerRef) {}
}
